import React from 'react';
import { View } from 'react-native';
import { Icon } from 'LocalGluons/index';
import PropTypes from 'prop-types';
import style from './styles';

const LoadingContainer = ({ onBack, children, showHeader = true }) => (
    <View style={style.mainContainer}>
        <View style={style.behind}>{children}</View>
        <View style={[style.header, { opacity: showHeader ? 1 : 0 }]}>
            <View style={style.container}>
                <View style={style.backIconContainer}>
                    <Icon
                        style={style.backIcon}
                        onPress={onBack}
                        name="arrow_left"
                        testID="back_button"
                    />
                </View>
            </View>
        </View>
    </View>
);

LoadingContainer.propTypes = {
    onBack: PropTypes.func.isRequired
};

export default LoadingContainer;
